module.exports = {
          srcSet: __webpack_public_path__ + "9039117143f6bb3c2c5de5c0678378f7-1279.png"+" 1279w",
          images:[ {path: __webpack_public_path__ + "9039117143f6bb3c2c5de5c0678378f7-1279.png",width: 1279,height: 538}],
          src: __webpack_public_path__ + "9039117143f6bb3c2c5de5c0678378f7-1279.png",
          toString:function(){return __webpack_public_path__ + "9039117143f6bb3c2c5de5c0678378f7-1279.png"},
          placeholder: "data:image/png;base64,UklGRooAAABXRUJQVlA4WAoAAAAQAAAACQAAAwAAQUxQSCkAAAAAAAAAAAACVxoVAAAAAAAAIPZiCQAAAAAAACT/WQAAAAAAAAAMRhUAAABWUDggOgAAAPABAJ0BKgoABAABQCYlnAJ0fwAaoklXIAD++cNbe942H/26DuRtd0M/hTMmGSASn3N1e2WksJ3YAAA=",
          width: 1279,
          height: 538
        }